export const formatName = (text) => {
  if (!text) return "";

  const exceptions = ["de", "del", "de la", "y", "s.a.", "c.v."];
  return text
    ?.toLowerCase()
    .split(" ")
    .map((word) => {
      return exceptions.includes(word)
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

export const formatEmpresa = (text = "") => {
  if (!text) return "";

  // Normaliza quitando puntos innecesarios para evitar duplicaciones
  let cleanText = text
    .toLowerCase()
    .replace(/\./g, "") // quita puntos de s.a, c.v, etc.
    .replace(/\s+/g, " ") // elimina dobles espacios
    .trim();

  // Capitalizacion con excepciones
  const excepciones = ["de", "y", "la", "del"];
  const capitalizado = cleanText
    .split(" ")
    .map((word) =>
      excepciones.includes(word)
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");

  // Reemplazos
  let resultado = capitalizado;
  resultado = resultado.replace(/\bSa\b/gi, "S.A.");
  resultado = resultado.replace(/\bCv\b/gi, "C.V.");
  resultado = resultado.replace(/\bRl\b/gi, "R.L.");
  resultado = resultado.replace(/\bS\.A\.\s+de\s+C\.V\.\b/gi, "S.A. de C.V.");
  resultado = resultado.replace(/\bS\s+de\s+R\.L\.\b/gi, "S. de R.L.");

  return resultado;
};

// Función para capitalizar la primera letra de cada palabra
export const capitalize = (text) => {
  if (typeof text === "string") {
    return text
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  return ""; // o null, si prefieres
};

//RESALTAR COINCIDENCIAS EN CELDAS PERSONALIZADAS
export const highlightText = (text, highlight) => {
  if (!highlight) return text;
  const regex = new RegExp(`(${highlight})`, "gi");
  const parts = text.split(regex);
  return parts.map((part, i) =>
    part.toLowerCase() === highlight.toLowerCase() ? (
      <span
        key={i}
        style={{
          backgroundColor: "#fff59d", // amarillo suave
          color: "black",
          fontWeight: "bold",
        }}
      >
        {part}
      </span>
    ) : (
      part
    )
  );
};

//Formato en cobertura
export const formatCobertura = (text = "") => {
  if (!text) return "Sin cobertura";
  return text.replace(/,/g, ", ");
};

//Formato en especialidades
export const formatEspecialidades = (especialidades = []) => {
  if (!Array.isArray(especialidades) || especialidades.length === 0) {
    return "Sin especialidades";
  }
  return especialidades.map((c) => c.nombre).join(", ");
};
